import config from '@/config'
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ru from './locales/ru.json'
import { ruPluralForm } from './pluralRules.js'
import { readStoredAppLocale } from './localeStorage.js'

/**
 * Словари полей живут в history.fields (нужны history-фразам).
 * Формы/списки справочников обращаются к catalog.fields — шарим тот же объект.
 */
function withCatalogFieldsAlias(messages) {
  for (const locale of Object.keys(messages)) {
    const m = messages[locale]
    if (m?.history?.fields && m.catalog && !m.catalog.fields) {
      m.catalog.fields = m.history.fields
    }
  }
  return messages
}

/**
 * Глобальный инстанс vue-i18n для RTMS.
 * Основная локаль UI — русский; английский — fallback и запас для будущих переводов.
 */
export const i18n = createI18n({
  legacy: false,
  locale: readStoredAppLocale(),
  fallbackLocale: 'en',
  messages: withCatalogFieldsAlias({
    en,
    ru,
  }),
  pluralRules: {
    ru: ruPluralForm,
  },
  /**
   * Глобальные именованные форматы для `d()` в Composition API.
   * @see https://vue-i18n.intlify.dev/guide/advanced/composition.html#datetime-formatting
   */
  datetimeFormats: {
    ru: {
      print: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      },
    },
    en: {
      print: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      },
    },
  },
  /**
   * Глобальные именованные форматы для `n()` в Composition API.
   * @see https://vue-i18n.intlify.dev/guide/advanced/composition.html#number-formatting
   */
  numberFormats: {
    ru: {
      decimal2: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      integer: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    en: {
      decimal2: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      integer: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
  },
  // В основном проверка идёт через линтер, поэтому по умолчанию отключаем предупреждения
  missingWarn: config.VITE_LOCALE_MISSING_WARN === 'true' || false,
  fallbackWarn: config.VITE_LOCALE_FALLBACK_WARN === 'true' || false,
})
